if (typeof $$epiforms !== 'undefined') {
  $$epiforms(document).ready(function myfunction() {

    jQuery.expr[':'].focus = function (elem) {
      return elem === document.activeElement && (elem.type || elem.href);
    };

    $$epiforms(".EPiServerForms").on("formsSubmitted",
      function (event, param1, param2) {
        if (event.isSuccess) {
          $('[data-f-form-statusmessage]').addClass('demo');
        }
      });


    //disable chevron background image in multiple selects in forms
    $('.FormSelection').each(function () {
      var isMultipleSelect = $(this).find('select').attr('multiple');
      if (typeof isMultipleSelect !== typeof undefined && isMultipleSelect !== false) {
        $(this).addClass('noChevron');
      }
    });

    //set all datetime fields to readonly
    $('.FormDateTime').each(function (e) {
      $(this).find('input').attr('readonly', true);
    });

    //TODO should be enabled for MAU-396
    //Should import flatpickr to work (check date-picker.js)
    //$('.FormDateTime__Input').each(function (e) {
    //  initDatepicker($(this)); 
    //});

    $$epiforms(".EPiServerForms").on("formsSubmitted", function (event, param1, param2) {
      //var offsetExtra = 200;

      //if (!$(event.currentTarget).closest('.form-block').hasClass('text--accordion')) {
      //  offsetExtra = 200;
      //}

      $('html, body').animate({
        scrollTop: $(event.currentTarget).closest('.form-block').find('.Form__Status').offset().top - 200
          },
          300);
    });
  });
}

function initDatepicker(dateTimeElement) {

  var enableTime = true;
  var dateFormat = "";
  var noCalendar = false;

  if (isDateTimePicker(dateTimeElement)) {
    dateFormat = "Y-m-d H:i";
  }
  else if (isDatePicker(dateTimeElement)) {
    dateFormat = "Y-m-d";
    enableTime = false;
  }
  else if (isTimePicker(dateTimeElement)) {
    dateFormat = "H:i";
    noCalendar = true;
  }
  else {
    //its not a valid dateField
    console.error("Invalid markup for datepicker element with id " + $(dateTimeElement).attr('id') + " - perhaps an update has broken the Episerver.Forms datetime element structure?");
    return;
  }

  var datePickerConfig = {
    dateFormat: dateFormat,
    locale: "sv",
    allowInput: false,
    enableTime: enableTime,
    time_24hr: true,
    noCalendar: noCalendar,
    onClose: function (dateObj, dateStr) {
      setTimeout(function () {
        var AmPmTime = convertToAmPm($(dateTimeElement));
        dateTimeElement.val(AmPmTime);
      }, 100);
    }
  };

  flatpickr.localize(flatpickr.l10ns.sv);
  flatpickr(dateTimeElement, datePickerConfig);
}

function isDateTimePicker(element) {
  return $(element).parent().find("script").text().includes('pickerType: "datetimepicker"');
}

function isDatePicker(element) {
  return $(element).parent().find("script").text().includes('pickerType: "datepicker"');
}

function isTimePicker(element) {
  return $(element).parent().find("script").text().includes('pickerType: "timepicker"');
}

function convertToAmPm(dateTimeElement) {
  var element = $(dateTimeElement);
  if (element.val() && element.val() !== 'undefined') {

    if (element.val().length === 16) {
      //element is a dateTime
      //convert date format to ISO-8601
      var date = element.val().substr(0, 10);

      var time = new Date(getYear(element), getMonth(element), getDay(element), getHour(element), getMinute(element), 0).toLocaleTimeString('en-US', { timeStyle: 'short' , hour: '2-digit', minute:'2-digit'});

      if (time.length === 7) {
        time = '0' + time;
      }
      if (time.length) {
        time = ' ' + time;
      }

      return date + time;
    }
    else if (element.val().length === 5) {
      //element is a time string
      var timeInAmPm = new Date(1920, 1, 1, getHour(element), getMinute(element), 0).toLocaleTimeString('en-US', { timeStyle: 'short', hour: '2-digit', minute: '2-digit' });
      if (timeInAmPm.length === 7) {
        timeInAmPm = '0' + timeInAmPm;
      }
      return timeInAmPm;
    }
  }
  //element is a datestring without time
  return element.val();
}

function getYear(dateTimeElement) {
  return $(dateTimeElement).val().substr(0, 4);
}

function getMonth(dateTimeElement) {
  return $(dateTimeElement).val().substr(5, 2);
}

function getDay(dateTimeElement) {
  return $(dateTimeElement).val().substr(8, 2);
}

function getHour(dateTimeElement) {
  if ($(dateTimeElement).val().length === 5) {
    return $(dateTimeElement).val().substr(0, 2);
  }
  return $(dateTimeElement).val().substr(11, 2);
}

function getMinute(dateTimeElement) {
  if ($(dateTimeElement).val().length === 5) {
    return $(dateTimeElement).val().substr(3, 2);
  }
  return $(dateTimeElement).val().substr(14, 2);
}
